






























































































































































































































import AlertBar from '@/components/AlertBar.vue'
import InfoBanner from '@/components/InfoBanner.vue'
import Vue from 'vue'
import Analytics from '@/services/Analytics'
import { mapGetters } from 'vuex'
export default Vue.extend({
    components: { AlertBar, InfoBanner },
    data: () => ({
        adminPassword: null,
        comment: null,
        competitorComment: null,
        competitors: [
            'SalesMsg',
            'OpenPhone',
            'SimpleTexting',
            'Avochato',
            'HeyMarket',
            'Other'
        ],
        discount: 'wiBiOYWG',
        incorrectPassword: false,
        loading: false,
        otherCompetitor: null,
        selectedCompetitor: null,
        selectedReason: null,
        step: 1,
        succeedComment: null
    }),
    computed: {
        ...mapGetters([
            'adminUser',
            'isApp',
            'plan',
            'productTier',
            'smsAccount',
            'subscription',
            'subscriptionItems',
            'tenant',
            'trialing'
        ]),
        adminEmail(): string {
            //  Find our admin
            const admin = this.adminUser

            //  If there is no admin, return nothing
            if (!admin) return null

            //  Else, grab the email from our admin
            const email = admin.email

            //  Return the admin's email
            return email
        },
        annualPrice(): number {
            //  Grab our plan
            const plan = this.plan

            //  If no plan, return null
            if (!plan) return null

            //  Else, grab the interval
            const interval = plan.interval

            //  Calculate the base price for the plan
            const basePrice = this.planPrice

            //  Calculate the cost per user for the plan taking into account monthly vs annual
            const usersPrice = this.usersPrice

            //  Get our pre final price
            const prePrice = basePrice + usersPrice

            //  If our interval is monthly then we need to multiply this by 12
            const finalPrice = interval === 'year' ? prePrice : prePrice * 12

            //  Return the final price
            return finalPrice
        },
        competitorEmpty(): boolean {
            //  If we have no comment, return true
            if (!this.competitorComment) return true

            //  If we don't have a selected competitor, return true
            if (!this.selectedCompetitor) return true

            //  If our competitor is Other and we haven't selected an Other, return true
            if (this.selectedCompetitor === 'Other' && !this.otherCompetitor) return true

            //  Else, return false
            return false
        },
        endPeriod(): string {
            //  If our sub doesn't exist, return null
            if (!this.subscription) return null

            //  Else, grab our period end
            return this.subscription.current_period_end
        },
        infoBanners() {
            return [
                {
                    bgColor: '#F3EEEA',
                    // cta: 'Contact Support',
                    // ctaCallback: () => this.popIntercomMessenger(),
                    icon: 'bi-question-circle-fill',
                    iconColor: '#E7A730',
                    text: 'Have Issues or Questions? Our support team can help with any problems you may be encountering. Email us at support@messagedesk.com'
                },
                {
                    bgColor: '#F3EEEA',
                    cta: 'Move my Phone Number',
                    ctaCallback: () => console.log('move phone number TODO'),
                    id: 'move-my-phone-number',
                    icon: 'bi-question-circle-fill',
                    iconColor: '#E7A730',
                    text: 'Need to migrate your MessageDesk phone number? Be sure to do so before cancelling your subscription.'
                },
                // {
                //     bgColor: '#ECE8F8',
                //     cta: 'Change Plan',
                //     ctaCallback: () => this.changePlan(),
                //     icon: 'bi-exclamation-circle-fill',
                //     iconColor: '#8168C0',
                //     text: 'Try a Different Plan. Unsatisfied with your plan? Choose a better option.'
                // }
            ]
        },
        planPrice(): number {
            //  If no plan, return nothing
            if (!this.plan) return null

            //  Return the plan's dollar amount
            return this.plan.amount / 100
        },
        radioButtons() {
            return [
                {
                    text: 'Too expensive'
                },
                {
                    text: 'Switching to a different app'
                },
                {
                    text: "Didn't find value"
                },
                {
                    text: 'Missing features I need'
                },
                {
                    text: this.trialing
                        ? "Coudn't get in touch with sales/support"
                        : 'Bad customer service'
                },
                {
                    text: 'No longer need MessageDesk <span class="mini-text">e.g. Project ended or business closed</span>'
                }
            ]
        },
        savings(): string {
            //  Multiply our final price by 0.3 to get the total discount
            const discount = this.annualPrice * 0.3

            //  Return this discount
            return `${discount.toFixed(2)}`
        },
        usersPrice(): number {
            //  Grab our subscription items
            const items = this.subscriptionItems

            //  Get our user plan from this subscription
            const userPlan = items.find((x) => {
                x.plan.nickname.includes('MessageDesk Users')
            })

            //  If no user plan, then the price is 0
            if (!userPlan) return 0

            //  else, grab our quantity from this item
            const quantity = userPlan.quantity

            //  Grab the cost
            const amount = userPlan.plan.amount

            //  Multiply these together to get our total
            const total = quantity * amount

            //  Multiply it by 0.01 to get it in decimal format
            return total * 0.01
        }
    },
    methods: {
        async applyDiscount(): Promise<void> {
            //  Start our loader
            this.loading = true

            //  Validate that our discount exists
            await this.$store.dispatch('couponsGet', this.discount)

            //  Our coupon is set in the store already so just call the method
            await this.$store.dispatch('couponsPost')

            //  Stop loader
            this.loading = false

            //  Go to the next step
            this.step = 4
        },
        async cancelSubscription(): Promise<void> {
            //  Set our error to false
            this.incorrectPassword = false

            //  Start loading
            this.loading = true

            //  We need to validate the password first
            const valid = await this.validatePassword()

            //  If invalid, stop loading and show an alert
            if (!valid) {
                this.loading = false
                this.incorrectPassword = true
                return
            }

            //  Send the cancel request to the API
            const sub = await this.$store.dispatch('subscriptionCancel')

            //  Stop loading
            this.loading = false

            //  Refresh the stripe customer
            this.$store.dispatch('stripeCustomerGet')

            //  Submit analytics
            this.submitAnalytics(false)

            //  Pop banner letting user know they are now cancelled
            this.$store.commit('appNotificationBarSet', {
                message: 'Subscription Cancelled',
                type: 'success'
            })

            //  Close
            this.$emit('submit')
        },
        changePlan(): void {
            //  Navigate to our manage plan page
            // this.$router.push('/billing/plan')
            this.$router.push('/billing/manage')

            //  Close our dialog
            this.$emit('close')
        },
        costPerUser(tier: string): number {
            //  Starter plans can't add users
            if (tier == 'Starter') return 10

            //  Operator plans can add users for $10 per user
            if (tier == 'Operator') return 10

            //  Team plans can add users for $15 per user
            if (tier == 'Team') return 15

            //  Default to $10 per user
            return 10
        },
        exit(): void {
            //  Submit analytics
            this.submitAnalytics(true)

            //  Close our form
            this.$emit('close')
        },
        popIntercomMessenger(): void {
            //  @ts-ignore If we are on the mobile app, then call our Cordova plugin
            if (this.isApp) intercom.displayMessenger()
            // Pops the intercom messenger through the id bound to the hidden span element
            else window.popSupportMessenger()
        },
        scheduleMeeting(): void {
            //  The link for our calendly meeting
            const url = 'https://calendly.com/d/cqdk-krr-g3n/messagedesk-account-meeting'

            //  Pop open this calendly meeting
            window.open(url, this.isApp ? '_system' : '_blank')

            //  Submit analytics
            this.submitAnalytics(true)

            //  Close our form
            this.$emit('submit', '/inbox')
        },
        submitAnalytics(mitigated: boolean): void {
            //  Our competitor depends on if selected competitor is "Other" or not
            const competitor =
                this.selectedCompetitor === 'Other'
                    ? this.otherCompetitor
                    : this.selectedCompetitor

            //  Create our payload
            const data = {
                cancellation_reason: this.selectedReason,
                churn_mitigated: mitigated,
                switching_to: competitor,
                detailed_cancellation_reason: this.comment,
                competitor_reason: this.competitorComment,
                discount_reason: this.succeedComment
            }

            //  Track the form being completed
            Analytics.track('SubscriptionCancellationFormCompleted', data)

            //  Do a group call as well
            Analytics.group(data)
        },
        submitComment(): void {
            //  Submit analytics
            this.submitAnalytics(true)

            //  Close our form
            this.$emit('submit', '/inbox')
        },
        routeStep(): void {
            //  Our step we go to depends on the reason the user picked
            const step =
                {
                    'Too expensive': 3,
                    'Switching to a different app': 5
                }[this.selectedReason] || 6

            //  Route to our step
            this.step = step
        },
        async validatePassword(): Promise<boolean> {
            //  Create our payload
            const payload = {
                password: this.adminPassword,
                tenant_id: this.tenant.id
            }

            //  Else, send the password confirm request to the API
            const result = await this.$store.dispatch('authUserConfirm', payload)

            //  Return the result
            return result
        }
    }
})
